import { Controller } from "@hotwired/stimulus"

// Data do evento só faz sentido em Eventos, e um campo permanentemente visível que não se aplica
// à maioria dos posts é ruído no formulário. Quais categorias contam vem do servidor
// (Category::AGENDA_SLUGS), não de uma lista repetida aqui.
export default class extends Controller {
  static targets = ["category", "field"]
  static values = { agendaIds: Array }

  connect() {
    this.toggle()
  }

  toggle() {
    const isAgenda = this.agendaIdsValue.includes(Number(this.categoryTarget.value))
    this.fieldTarget.hidden = !isAgenda
  }
}
